import { useLocation } from 'react-router-dom';

export interface NavigationTab {
	id: string;
	label: string;
	href: string;
}

export function useSelectedTab(tabs: NavigationTab[]) {
	const { pathname } = useLocation();
	const exactMatch = tabs.find(x => x.href === pathname);
	if (exactMatch) {
		return exactMatch.id;
	}
	return tabs.toSorted((a, b) => b.id.length - a.id.length).find(x => pathname.startsWith(x.href))?.id;
}
